import React from "react";
import { useInView } from "react-intersection-observer";
import Reveal from "react-awesome-reveal";
import "./skills.css";
import Frontend from "./Frontend";
import Backend from "./Backend";
import SoftwareSkill from "../softwareSkills/SoftwareSkill";

const Skills = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.5,
  });

  return (
    <div ref={ref}>
      <Reveal effect="fade" when={inView} triggerOnce={true}>
        <section className="skills section" id="skills">
          <h2 className="section__title">Skills</h2>
          <span className="section__subtitle">My tech stack</span>
          <div className="skills__container container">
            <SoftwareSkill />
            {/* <Frontend />
        <Backend /> */}
          </div>
        </section>
      </Reveal>
    </div>
  );
};

export default Skills;
